import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import Loader from '../common/Loader';

import { authHttp } from '../../utils/http';
import Alert from '../common/Alert';

const SendVerificationForm = () => {
  const [isLoading, setLoading] = useState(true);

  const [error, setError] = useState();

  useEffect(() => {
    authHttp('/v1/account/resend-verification-email', 'POST')
      .then(() => {
        setLoading(false);
      })
      .catch((res) => {
        if (res.message) {
          setError(res.message);
        }

        setLoading(false);
      });
  }, []);

  const intl = useIntl();

  return (
    <>
      { isLoading
        ? (<Loader size={35} colored centered />)
        : error
          ? (
            <Alert
              title={intl.formatMessage({
                id: 'sendEmailVerification.title.error',
                defaultMessage: 'Something went wrong!',
                description: 'Title of the page, in case sending a verification email failed. Is followed by a error description'
              })}
              description={error}
              icon="error"
            />
          )
          : (
            <Alert
              title={intl.formatMessage({
                id: 'sendEmailVerification.title.success',
                defaultMessage: 'Hurray! Just one more thing.',
                description: 'Title of the page, in case sending a verification email succeeded'
              })}
              description={intl.formatMessage({
                id: 'sendEmailVerification.text.success',
                defaultMessage: 'We’ve sent you a confirmation email. Please, open it and hit “Confirm your email” to complete registration.',
                description: 'Text directing user to complete email verification by clicking the link in the email that had just been sent'
              })}
              icon="success"
            />
          )}
    </>
  );
};

export default SendVerificationForm;
